import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { TruckHero } from './components/TruckHero';
import { SpecialOffers } from './components/SpecialOffers';
import { MenuSection } from './components/MenuSection';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="min-h-screen w-full bg-night font-sans font-light text-cream selection:bg-gold selection:text-ink" data-id="element-0" data-mp="3fa88j72bos5w">
      <SiteHeader data-id="element-1" data-mp="2rlox4inz7z9l" />
      <main data-id="element-2" data-mp="2rit1j0zlpmob">
        <TruckHero data-id="element-3" data-mp="2rikmp3jx47ah" />
        <SpecialOffers data-id="element-4" data-mp="2mm2n0i3g2z50" />
        <MenuSection data-id="element-5" data-mp="2mmvlyww5wkcl" />
      </main>
      <SiteFooter data-id="element-6" data-mp="2mnne1xqjvzy4" />
    </div>;
}